const initialState = {
  list: [],
  listLoading: false,
  listError: null,
  key: null,
  getLoading: false,
  getError: null,
  createLoading: false,
  createError: null,
  updateLoading: false,
  updateError: null,
  deleteLoading: false,
  deleteError: null,
  verifyLoading: false,
  verifyError: null
};

export default (state = initialState, { type, payload, meta }) => {
  switch (type) {
    case 'LIST_DKIM_KEYS_PENDING':
      return { ...state, listLoading: true, listError: null };

    case 'LIST_DKIM_KEYS_SUCCESS':
      return { ...state, list: payload, listLoading: false };

    case 'LIST_DKIM_KEYS_FAIL':
      return { ...state, listError: payload, listLoading: false };

    case 'GET_DKIM_KEY_PENDING':
      return { ...state, getLoading: true, getError: null };

    case 'GET_DKIM_KEY_SUCCESS':
      return { ...state, key: payload, getLoading: false };

    case 'GET_DKIM_KEY_FAIL':
      return { ...state, getError: payload, getLoading: false };

    case 'CREATE_DKIM_KEY_PENDING':
      return { ...state, createLoading: true, createError: null };

    case 'CREATE_DKIM_KEY_SUCCESS':
      return { ...state, createLoading: false };

    case 'CREATE_DKIM_KEY_FAIL':
      return { ...state, createLoading: false, createError: payload };

    case 'UPDATE_DKIM_KEY_PENDING':
      return { ...state, updateLoading: true, updateError: null };

    case 'UPDATE_DKIM_KEY_SUCCESS':
      return { ...state, updateLoading: false };

    case 'UPDATE_DKIM_KEY_FAIL':
      return { ...state, updateLoading: false, updateError: payload };

    case 'DELETE_DKIM_KEY_PENDING':
      return { ...state, deleteLoading: true, deleteError: null };

    case 'DELETE_DKIM_KEY_SUCCESS':
      return {
        ...state,
        deleteLoading: false,
        list: state.list.filter((key) => key.id !== meta.keyId)
      };

    case 'DELETE_DKIM_KEY_FAIL':
      return { ...state, deleteLoading: false, deleteError: payload };

    case 'VERIFY_DKIM_KEY_PENDING':
      return { ...state, verifyLoading: true, verifyError: null };

    case 'VERIFY_DKIM_KEY_SUCCESS':
      return {
        ...state,
        verifyLoading: false,
        list: state.list.map((key) =>
          key.id === meta.keyId ? { ...key, dkim_status: payload.dkim_status } : key
        )
      };

    case 'VERIFY_DKIM_KEY_FAIL':
      return { ...state, verifyLoading: false, verifyError: payload };

    case 'CLEAR_DKIM_KEYS':
      return initialState;

    default:
      return state;
  }
};
